var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudentAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.78 11.572a5.33 5.33 0 0 0 2.22.488 5.31 5.31 0 0 0 2.221-.488h.338c1.275 0 2.418.56 3.2 1.445A6.498 6.498 0 0 1 10 16.5a6.5 6.5 0 0 1-5.757-3.48 4.246 4.246 0 0 1 3.199-1.448h.338zM10 3.19a3.899 3.899 0 1 1 0 7.798 3.899 3.899 0 0 1 0-7.798z",
  fillRule: "evenodd"
})));
export default SvgStudentAvatar;